// Packages
import PropTypes from 'prop-types'

// Components
import ContractJobForm from 'modules/ContractJobs/components/Form';

// Other
import useApi from 'hooks/useApi';

const ContractJobEditScreen = ({  itemId, onClose, onSubmit }) => {

    const { data: item, put: updateItem, errors } = useApi('/contractjobs/' + itemId + '?with=engineers');

	const submit = async (values) => {

        if( await updateItem(values, 'Contract Job updated!')) {

            onSubmit();
        }
    }

    return(
        <ContractJobForm 
            errors={errors} 
            contract_job={item} 
            onClose={onClose} 
            onSubmit={submit} 
            type='edit' 
        />
    )
}

ContractJobEditScreen.propTypes = {
    itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClose: PropTypes.func,
    onSubmit: PropTypes.func,
}

ContractJobEditScreen.defaultProps = {
    itemId: null,
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')}
}

export default ContractJobEditScreen;